import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import RPGIcon, { GetRPGIcon } from "source/app/presentation/Shared/RPGIcon/RPGIcon";
import { Style } from "../../../../Shared/Styles/CSS";

export function DailyGoalGoalIcon({ goal }: { goal: IGoal; }) {
    return (
        <span
            {...Style(`dailyGoalIcon`, {
                position: "relative",
                top: "1px",
                padding: "0px 5px",
                fontSize: "16px",
            })}
        >
            <RPGIcon icon={GetRPGIcon(goal.icon)} />
        </span>
    );
}
